import agency from './agency';
import bill from './bill';
import purse from './purse';
import recharge from './recharge';
import rule from './rule';
import task from './task';

export default {
  common: {
    success: 'Başarılı',
    days: 'Günler',
    task: 'Görev',
    next: 'Sonraki',
    previous: 'Öncesi',
    change: 'Değiştir',
    noData: 'Veri yok',
    cancel: 'İptal',
    rule: 'Kural',
    exchange: 'Değişim',
    confirm: 'Onaylamak',
    notice: 'Duyuru',
    send: 'Gönder',
    received: 'Alındı',
    recipient: 'Alıcı',
    agency: 'Ajans',
    country: 'Ülke',
    channel: 'Kanal',
    account: 'Hesap',
    fullName: 'Tam Ad',
    currency: 'Para Birimi',
    bankName: 'Banka Adı',
    bankCode: 'Banka Kodu',
    address: 'Adres',
    targetOrg: 'Hedef Organizasyon',
    save: 'Kaydet',
    ID: 'ID: {{id}}',
    bank: 'Banka',
    invite: 'Davet etmek',
    information: 'Bilgi',
    edit: 'Düzenle',
    announcement: 'Duyuru',
    member: 'Üye',
    taskn: 'Görev {{n}}',
    fromAlbum: 'Albümden',
    takePhoto: 'Fotoğraf Çek',
    delete: 'Sil',
    supportCountry: 'Desteklenen Ülke',
    enter: 'Gir',
    noUser: 'kullanıcı bulunamadı',
    enterId: 'ID Gir',
    recharge: 'Yükleme',
    warning: 'Uyarı',
    topUp: 'Yükle',
  },
  error: {
    systemFatal: 'Bir şeyler ters gitti. Lütfen daha sonra tekrar deneyin.',
  },
  agency,
  bill,
  purse,
  recharge,
  rule,
  task,
};
